import React, { forwardRef, useState } from 'react';

import { Datepicker } from '@mobiscroll/react';
import moment from 'moment/moment';

import { GeneralDatepickerStyled } from './GeneralDatepicker.style';
import GeneralDatepickerInput from './GeneralDatepickerInput';
import InlineDatePickerHeader from './components/InlineDatePickerHeader';

import type { Moment } from 'moment';
type GeneralDatepickerProps = {
  labelId?: string;
  inputId?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  isRange?: boolean;
  label?: string;
  placeholder?: string;
  value?: string;
  helperText?: string;
  isButton?: boolean;
  errorMessage?: string;
  size?: 'small' | 'medium';
  dateFormat?: string;
  onChange: (date: Moment | [Moment | null, Moment | null] | null) => void;
  isClearable?: boolean;
  [x: string]: any;
};

export const GeneralDatepicker = forwardRef<HTMLHeadingElement, GeneralDatepickerProps>((props, ref) => {
  const [isShowPopup, setIsShowPopup] = useState(false);
  const {
    labelId,
    inputId,
    isDisabled,
    isError,
    isFullWidth = true,
    isRequired,
    isReadOnly = false,
    isButton,
    errorMessage,
    label,
    placeholder,
    isClearable,
    helperText,
    value,
    size,
    dateFormat,
    onChange,
    ...args
  } = props;
  const onOpenPopup = () => {
    setIsShowPopup(true);
  };
  const onClosePopup = () => {
    setIsShowPopup(false);
  };

  const handleChange = (val: any) => {
    onChange(val.value);
  };
  return (
    <GeneralDatepickerStyled>
      <Datepicker
        {...args}
        cssClass="date-picker"
        inputRef={ref}
        themeVariant="light"
        moment={moment}
        onChange={handleChange}
        onOpen={onOpenPopup}
        onClose={onClosePopup}
        defaultValue={value}
        focusOnClose={false}
        disabled={isDisabled}
        renderCalendarHeader={InlineDatePickerHeader}
        dayNamesMin={['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']}
        controls={['calendar']}
        theme="ios"
        returnFormat="moment"
        dateFormat={dateFormat || 'MMM DD YYYY'}
        touchUi={false}
        inputComponent={GeneralDatepickerInput}
        inputProps={{
          labelId,
          inputId,
          isClearable,
          label,
          errorMessage,
          isFullWidth,
          isDisabled,
          isReadOnly,
          isButton,
          isRequired,
          onChange,
          isError,
          placeholder,
          helperText,
          size,
          value,
          isShowPopup,
          dateFormat,
        }}
      />
    </GeneralDatepickerStyled>
  );
});
